export const GET_PRODUCTS = "products/get"
export const POST_PRODUCT = "product/post"
export const DELETE_PRODUCT = "product/delete"
export const EDIT_PRODUCT = "product/edit"
export const SEARCH_BY_QUERY = "product/query"


